import http from '@/http'
const URL = '/admin/photos'

export const listPhotos = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const getPhoto = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const savePhoto = (payload) => {
  if (!payload.get('id')) {
    return http.post(URL, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
  }
  return http.post(URL + `/${payload.get('id')}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export const deletePhoto = async (id) => http.delete(URL + `/${id}`)

export const orderList = async (payload) => http.put(URL + `/reorder`, payload)

export default {
  listPhotos,
  getPhoto,
  savePhoto,
  changeStatus,
  deletePhoto,
  orderList
}
